var React = require('react');
var { sanitize } = require('isomorphic-dompurify');
var { $form } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var labels = require('MemberJoinLabels');
var ChangeStepButtons = require('../ChangeStepButtons/changeStepButtons.jsx');

class Step0 extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    bindFunctions() {
        this.prevStepValid = this.prevStepValid.bind(this);
        this.nextStepValid = this.nextStepValid.bind(this);
    }

    prevStepValid() {
        return this.props.appState.currentStep > 0;
    }

    nextStepValid() {
        return this.props.appState.currentStep < 6;
    }

    render() {

        const itemsYouNeed = sanitize(labels.itemsYouWillNeedContent);
        const stateComponentContent = sanitize(labels.stateComponentDuesContent);
        const bottomContent = sanitize(labels.bottomContent);
        return <div className={"step-0-container"}>
            <$form onSubmit={(event) => this.props.goToStep(event, 1)} ref={c => { this.form = c }}>

                <p>{labels.introduction}</p>

                <div className={"accordionItem close"}>
                    <button type="button" className={"accordionItemHeading has-dropdown"}>{labels.itemsYouWillNeedTitle}</button>
                    <div className={"accordionItemContent"}>
                        <p dangerouslySetInnerHTML={{ __html: itemsYouNeed}}></p>
                    </div>
                </div>

                <div className={"accordionItem close"}>
                    <button type="button" className={"accordionItemHeading has-dropdown"}>{labels.stateComponentDuesTitle}</button>
                    <div className={"accordionItemContent"}>
                        <p dangerouslySetInnerHTML={{ __html: stateComponentContent }}></p>
                    </div>
                </div>

                <p dangerouslySetInnerHTML={{ __html: bottomContent }}></p>


                <ChangeStepButtons
                    disableUI={this.props.appState.disableUI}
                    nextStepValid={this.nextStepValid}
                    prevStepValid={this.prevStepValid}
                    goPrevStep={this.props.goPrevStep}
                    currentStep={this.props.appState.currentStep}
                    nextLabel={"Begin"}/>
            </$form>
        </div>;
    }
}

module.exports = Step0;